import { useState, useEffect }  from 'react';
import { Link, useNavigate  }   from 'react-router-dom';

import logoSideBar              from '../assets/NavBar/logo-sidebar.svg';
import logoSideBarHorizontal    from '../assets/NavBar/logo-horizontal.svg';
import iconLightHouse           from '../assets/NavBar/icon-traffic-light.svg';
import iconUser                 from '../assets/NavBar/circle-user.svg';
import iconHome                 from '../assets/NavBar/icon-home.svg';
import iconBackoffice           from '../assets/NavBar/icon-backoffice.svg';
import iconLogout               from '../assets/NavBar/icon-logout.svg'
import iconUpload               from '../assets/NavBar/icon-upload.svg'
import iconTable                from '../assets/NavBar/icon-table.svg'
import iconJustifications       from '../assets/NavBar/icon-justifications.svg'
import iconSimulation           from '../assets/NavBar/icon-simulation.svg'
import iconSilo                  from '../assets/NavBar/icon-silo.svg'
import iconShiftChange          from '../assets/NavBar/icon-shiftChange.svg'
import iconTrain                from '../assets/NavBar/icon-train.svg'

import { useUser }              from '../contexts/UserContext.js'      
import { findPermission }       from '../utils/UserPermissionUtils.js'  

import '../../src/styles/NavBar.css';

function NavBar() {

    //hooks
    const [isSubmenuOpen, setIsSubmenuOpen] = useState(false);
    const [isHovered, setIsHovered]         = useState(false);

    const { logout, userData }      = useUser()
    const navigate                  = useNavigate()

    const [fullName, setFullName] = useState(null)
    const [username, setUsername] = useState(null)
    
    const handleMouseLeave = () => {  
        
        setIsHovered(false);
        setIsSubmenuOpen(false); 

    }   
    
    const toggleSubmenu = () => {
        
        setIsSubmenuOpen(!isSubmenuOpen)

    }

    const handleLogout = () => {
        
        logout();
        navigate("/")
    }

    useEffect(()=>{ 

        if(!userData) return 

        const { fullName, username } = userData

        setFullName(fullName) 
        setUsername(username)

    }, [ userData ])
       


    return (
       
        <aside className="aside" onMouseEnter={() => setIsHovered(true)} onMouseLeave={handleMouseLeave}>

            <header className="header">
                <div className="logoContainer">
                    <img className={`logo ${isHovered ? 'expanded' : ''}`} alt="Logo na versão mínima da FIPS" width={isHovered ? "156" : "40"} height="50.51" src={isHovered ? logoSideBarHorizontal : logoSideBar} />
                </div>
            </header>

            <nav className="nav">
                
                <div>
                    
                    {/* Home */}
                    <Link to="/home" className="options">
                        
                        <div className="options">
                            
                            <img className="iconsOptions" width="22px" height="22px" alt="Ícone Home" src={iconHome} />
                            <span className="span">Home</span>
                        
                        </div>
                    
                    </Link>

                    {/* Farol dos Terminais */}
                    {findPermission(userData, "Acesso à Pagina de Faróis") && (
                        <div className="options-group">
                            
                            <div className="options" onClick={toggleSubmenu}>
                                
                                <img className="iconsOptions" width="22px" height="22px" alt="Ícone Farol" src={iconLightHouse} />
                                <span className="span">Farol dos Terminais</span>
                            
                            </div>

                            <div className={`submenu ${isSubmenuOpen ? 'open' : ''}`}>
                                
                                {findPermission(userData, "Acesso Dashboard") && (

                                    <Link to="/farol/dashboard" className="optionsSubmenu">

                                        <span className="spanSubmenu">Dashboard</span>

                                    </Link>
                                )}
                                

                                {findPermission(userData, "Acesso à Pagina de Faróis") && (

                                    <Link to="/farol/manage" className="optionsSubmenu">

                                        <span className="spanSubmenu">Dados dos Faróis</span>

                                    </Link>
                                )}

                            </div>
                            
                        </div>
                    )}

                    {/* Enviar Demanda */}
                    {findPermission(userData, "Acesso à Pagina de Demandas") && (

                        <Link to="/inputFile" className="options">
                            
                            <img className="iconsOptions" width="22px" height="22px" alt="Ícone Download" src={iconUpload} />
                            <span className="span">Demandas</span>
                        
                        </Link>
                    )}

                    {/* PxO */}
                    {findPermission(userData, "Acesso à Pagina de PxO") && (

                        <Link to="/pxo" className="options" >
                            
                            <img className="iconsOptions" width="22px" height="22px" alt="Ícone PxO" src={iconTable} fill="white"/>
                            <span className="span">PxO</span>
                        
                        </Link>
                    )}

                    {/* Árvore de Justificativas */}
                    {findPermission(userData, "Acesso à Pagina de Justificativas") && (

                        <Link to="/justificationPage" className="options">

                            <img className="iconsOptions" width="22px" height="22px" alt="Ícone Justificativas" src={iconJustifications} fill="white"/>
                            <span className="span">Árvore de Justificativas</span>

                        </Link>
                    )}

                    {/* Backoffice */}
                    {findPermission(userData, "Acesso à Pagina de BackOffice") && (

                        <Link to="/backoffice" className="options">

                            <img className="iconsOptions" width="22px" height="22px" alt="Ícone Backoffice" src={iconBackoffice} fill="white"/>
                            <span className="span">Backoffice</span>

                        </Link>
                    )}

                    {/* Simulação Anylogic */}  
                    {findPermission(userData, "Acesso à Pagina de Simulação") && (
                        
                        <Link to="/simulationAnylogicPage" className="options">

                            <img className="iconsOptions" width="22px" height="22px" alt="Ícone Simmulação" src={iconSimulation} fill="white" color='white'/>
                            <span className="span">Simulação Anylogic</span>

                        </Link>
                    
                    )}

                    {/* Balanço de Massa */}
                    {findPermission(userData, "Acesso à Pagina de Balanço de Massa") && (
                        
                        <Link to="/MassBalancePage" className="options">
                            
                            <img className="iconsOptions" width="22px" height="22px" alt="Ícone Silo" src={iconSilo} fill="white"/>

                            <span className="span">Balanço de Massa</span>
                            
                        </Link>
                    
                    )}

                    {/* Troca de Turno */}
                    {findPermission(userData, "Acesso à Pagina de Troca de Turno") && (

                    <Link to="/shiftChangePage" className="options">

                        <img className="iconsOptions" width="22px" height="22px" alt="Ícone Passagem de Turno" src={iconShiftChange} fill="white"/>

                        <span className="span">Passagem de Turno</span>

                    </Link>
                    )}

                    {/* Fila de Trens */}
                    {findPermission(userData, "Acesso à Pagina de Slots Baixada") && (

                        <Link to="/trainQueuePage" className="options">

                            <img className="iconsOptions" width="22px" height="22px" alt="Ícone Slots Baixada" src={iconTrain} />

                            <span className="span">Slots Baixada</span>

                        </Link>
                    )}

                    
                </div>
                    

                {/* Logout */}
                <div  className="options" onClick={handleLogout}>
                    
                    <img className="iconsOptions w-[18px] xl:w-[22px]" width="22px" height="22px" alt="Ícone Logout" src={iconLogout} fill="white"/>
                    <span className="span">Encerrar sessão</span>
                
                </div>

                {/* Usuário */}
               <div className="options fixed bottom-0" id="options">
  
                    <img
                        className="iconsOptions w-[18px] xl:w-[22px]"
                        width="22px"
                        height="22px"
                        alt="Ícone Usuário"
                        src={iconUser}
                        fill="white"
                    />

                    <div className="user-info flex flex-col">
                        <span
                            className="userName truncate max-w-[150px]"
                            title={fullName}
                        >
                            {fullName}
                        </span>

                        <span 
                            className="userCs truncate max-w-[150px]" 
                            title={username}
                        >
                            {username}
                        </span>
                    </div>

                </div>
            </nav>

        </aside>
    );
}

export default NavBar;